<template>
    <div @mouseleave="showSubNavigation = false">
        <div class="navigation-drawer">
            <v-list
                nav
                class="row align-space-between navigation-content screen-width"
                style="padding: 0px"
            >
                <v-list-item
                    style="height: 100%"
                    value="product"
                    @click="selectMenu(0)"
                >
                    <router-link to="/">
                        <v-img :src="kumhomarine_logo" width="180"> </v-img>
                    </router-link>
                </v-list-item>
                <div class="row" @mouseover="showSubNavigation = true">
                    <v-list-item
                        class="menu"
                        style="height: 100%"
                        value="notice"
                        @mouseover="subNavigationSection = 0"
                    >
                        <p class="navigation-item">문제해결</p>
                    </v-list-item>
                    <v-list-item
                        class="menu"
                        style="height: 100%; padding-left: 72px"
                        value="data"
                        @mouseover="subNavigationSection = 1"
                    >
                        <p class="navigation-item">기술자료실</p>
                    </v-list-item>
                    <v-list-item
                        class="menu"
                        style="height: 100%; padding-left: 72px"
                        value="as"
                        @mouseover="subNavigationSection = 2"
                    >
                        <p class="navigation-item">서비스 신청 및 조회</p>
                    </v-list-item>
                    <v-list-item
                        class="menu"
                        style="height: 100%; padding-left: 72px"
                        value="shop"
                        @mouseover="subNavigationSection = 3"
                    >
                        <p class="navigation-item">소모품샵</p>
                    </v-list-item>
                    <v-list-item
                        class="menu"
                        style="height: 100%; padding-left: 72px"
                        value="qna"
                        @mouseover="subNavigationSection = 4"
                    >
                        <p class="navigation-item">고객 지원</p>
                    </v-list-item>
                </div>
                <div class="row" style="gap: 20px; align-items: center">
                    <p style="color: white" v-if="isAuth">
                        {{ userName != null ? userName.name : "" }} 님
                    </p>
                    <router-link :to="'/login'" style="padding: 0px !important; display: flex; align-items: center; gap: 4px; text-decoration: none;">
                        <AccountOutline
                            v-if="!isAuth"
                            size="30"
                            class="custom-icon"
                            style="cursor: pointer"
                        ></AccountOutline>
                        <span v-if="!isAuth" style="color: white; font-size: 14px; cursor: pointer;">로그인</span>
                        <Logout
                            v-if="isAuth"
                            size="30"
                            class="custom-icon"
                            style="cursor: pointer"
                            @click="logout"
                        ></Logout>
                    </router-link>

                    <!-- <Magnify
                        size="30"
                        class="custom-icon"
                        style="cursor: pointer"
                    ></Magnify> -->
                </div>
            </v-list>
        </div>
        <!-- <transition name="slide"> -->
        <div class="sub-navigation" v-show="showSubNavigation">
            <div id="sub-navigation-content" class="screen-width">
                <div
                    class="nav-section column"
                    v-for="(nav, index) in nav_list"
                    :key="nav"
                    @mouseover="subNavigationSection = index"
                    :class="{ selected: subNavigationSection == index }"
                >
                    <p class="nav-title">
                        {{ nav.title }}
                    </p>
                    <router-link
                        class="nav-list"
                        v-for="item in nav.nav"
                        :key="item"
                        :to="item.path"
                        :style="{
                            color:
                                subNavigationSection == index
                                    ? 'white'
                                    : 'black',
                        }"
                        >{{ item.name }}</router-link
                    >
                </div>
            </div>
        </div>
        <!-- </transition> -->
    </div>
</template>
<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import kumhomarine_logo from "@/assets/kumhomarine_logo.png";
import AccountOutline from "vue-material-design-icons/AccountOutline.vue";
import Logout from "vue-material-design-icons/Logout.vue";
import Magnify from "vue-material-design-icons/Magnify.vue";

export default {
    name: "navigation-drawer",
    components: {
        AccountOutline,
        Magnify,
        Logout,
    },
    setup(_, { emit }) {
        const store = useStore();
        const selectMenu = (index) => {
            emit("selectMenu", index);
        };
        const showSubNavigation = ref(false);
        const subNavigationSection = ref(0);
        const nav_list = ref([]);

        const isAuth = computed(() => {
            return store.getters.getIsAuthenticated;
        });

        const userName = computed(() => {
            return store.getters.getUserProfile;
        });

        onMounted(() => {
            store.dispatch("getUserProfile").catch(() => {});
            nav_list.value = [
                {
                    title: "문제해결",
                    nav: [
                        {
                            name: "gps플로터",
                            path: {
                                path: "/problem",
                                query: { category: "GPS플로터" },
                            },
                        },
                        {
                            name: "레이더",
                            path: {
                                path: "/problem",
                                query: { category: "레이더" },
                            },
                        },
                        {
                            name: "무선/통신장비",
                            path: {
                                path: "/problem",
                                query: { category: "무선/통신장비" },
                            },
                        },
                        {
                            name: "항해 안전장비",
                            path: {
                                path: "/problem",
                                query: { category: "항해 안전장비" },
                            },
                        },
                        {
                            name: "항해 조타장비",
                            path: {
                                path: "/problem",
                                query: { category: "항해 조타장비" },
                            },
                        },
                        {
                            name: "해상용 안테나/헤딩센서",
                            path: {
                                path: "/problem",
                                query: { category: "해상용 안테나/헤딩센서" },
                            },
                        },
                        {
                            name: "선박용 인산철배터리",
                            path: {
                                path: "/problem",
                                query: { category: "선박용 인산철배터리" },
                            },
                        },
                        {
                            name: "선박용 전기관련 제품",
                            path: {
                                path: "/problem",
                                query: { category: "선박용 전기관련 제품" },
                            },
                        },
                        {
                            name: "부품 및 액세서리",
                            path: {
                                path: "/problem",
                                query: { category: "부품 및 액세서리" },
                            },
                        },
                        {
                            name: "단종제품",
                            path: {
                                path: "/problem",
                                params: { category: "부품 및 액세서리" },
                            },
                        },
                    ],
                },
                {
                    title: "기술자료실",
                    nav: [
                        { name: "다운로드", path: "/data/download" },
                        // { name: "알아두면 좋은 꿀팁", path: "/data/tip" },
                        { name: "동영상", path: "/data/video" },
                    ],
                },
                {
                    title: "서비스 신청 및 조회",
                    nav: [
                        { name: "AS 안내", path: "/service/guide" },
                        { name: "AS 접수", path: "/service/submit" },
                        { name: "교육 신청", path: "/service/lecture" },
                        { name: "AS 조회/변경/취소", path: "/service/check" },
                    ],
                },
                {
                    title: "소모품샵",
                    nav: [
                        {
                            name: "보험",
                            path: "/product",
                        },
                    ],
                },
                {
                    title: "고객지원",
                    nav: [
                        { name: "질문과 답변", path: "/customer/qna" },
                        { name: "정품 확인", path: "/customer/verify/product" },
                        { name: "칭찬합니다", path: "/customer/praise" },
                        { name: "개선해주세요", path: "/customer/complain" },
                    ],
                },
            ];
        });

        const logout = () => {
            store.dispatch("logout");
            alert("로그아웃 되었습니다.");
        };

        return {
            selectMenu,
            showSubNavigation,
            nav_list,
            subNavigationSection,
            kumhomarine_logo,
            isAuth,
            userName,
            logout,
        };
    },
};
</script>
<style scoped>
.v-list-item-title {
    font-size: 50px;
}
</style>

<style scoped>
.navigation-drawer {
    width: 100%;
    height: 80px;
    display: flex;
    color: white;
    background: #181e39;
    overflow: hidden;
}
.sub-navigation {
    width: 100%;
    /* height: 400px; */
    background: white;
    position: absolute;
    top: 72px;
    z-index: 1000;
    border-bottom: 1px solid black;
}

/* Transition 스타일 */
.slide-enter-active {
    max-height: 500px;
    transition: max-height 0.2s ease-in;
}
.slide-leave-active {
    max-height: 500px;
    transition: max-height 0.2s ease-in;
}
.slide-enter,
.slide-leave-to {
    max-height: 0;
}

#sub-navigation-content {
    height: 100%;
    margin: auto;
    background: white;
    display: flex;
}

.nav-section {
    flex: 1;
    border-left: 0.5px solid rgb(228, 228, 228); /* 왼쪽 테두리 */
    border-right: 0.5px solid rgb(228, 228, 228); /* 오른쪽 테두리 */
    padding: 32px 16px 0px 16px;
}

.selected {
    background: #01a7e7;
    color: white;
}

.navigation-content {
    height: 100%;
    margin: auto;
    background: transparent;
    overflow: hidden;
}

.menu {
    font-size: 16px;
    font-weight: 700;
}

.status-light {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    transition: background-color 0.3s ease;
}

.nav-title {
    font-size: 20px;
    font-weight: 700;
    padding-bottom: 32px;
}

a {
    font-size: 16px !important;
    font-weight: normal !important;
    padding-bottom: 12px !important;
}

.navigation-item {
    color: white;
    font-size: 16px;
}

span {
    color: rgb(207, 207, 207);
}
</style>
